// DisclosureGate.js — Jurisdiction-aware disclaimer overlay
import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { DISCLOSURE_TEXT } from '../../lib/projections/constants';

/**
 * Disclosure gate that blocks access until user acknowledges the disclaimer.
 * @param {{ onAcknowledge: Function }} props
 */
const DisclosureGate = ({ onAcknowledge }) => {
  const [checked, setChecked] = useState(false);

  return (
    <div className="bg-white border border-zinc-200 rounded-none p-8 max-w-2xl mx-auto mt-8">
      <div className="flex items-center gap-3 mb-5">
        <div className="w-10 h-10 bg-amber-50 border border-amber-200 rounded-none flex items-center justify-center flex-shrink-0">
          <AlertTriangle className="w-5 h-5 text-amber-600" />
        </div>
        <div>
          <h2 className="font-mono text-sm font-semibold text-zinc-800 uppercase tracking-wide">
            Important Disclosure
          </h2>
          <p className="font-mono text-[10px] text-zinc-500">
            Please read before proceeding
          </p>
        </div>
      </div>

      <div className="bg-zinc-50 border border-zinc-200 rounded-none p-4 mb-5 space-y-3">
        {DISCLOSURE_TEXT.map((text, i) => (
          <p key={i} className="font-mono text-[11px] text-zinc-600 leading-relaxed">
            {text}
          </p>
        ))}
      </div>

      <div className="flex items-start gap-2 mb-5">
        <input
          type="checkbox"
          id="disclosure-ack"
          checked={checked}
          onChange={e => setChecked(e.target.checked)}
          className="mt-0.5 rounded-none"
        />
        <label htmlFor="disclosure-ack" className="font-mono text-[11px] text-zinc-600 leading-relaxed cursor-pointer">
          I understand that this tool provides illustrative scenarios only, and does not constitute
          investment advice or a guarantee of future performance. I acknowledge that actual outcomes
          may differ materially from any scenario shown.
        </label>
      </div>

      <button
        onClick={onAcknowledge}
        disabled={!checked}
        className={`w-full py-2 font-mono text-[11px] uppercase tracking-wide rounded-none transition-colors ${
          checked
            ? 'bg-zinc-800 text-white hover:bg-zinc-900 cursor-pointer'
            : 'bg-zinc-200 text-zinc-400 cursor-not-allowed'
        }`}
      >
        I Understand and Wish to Proceed
      </button>
    </div>
  );
};

export default DisclosureGate;
